module.exports = __webpack_public_path__ + "img/008.e8048360.jpg";